import * as PropTypes from 'prop-types';
import Button from 'antd/lib/button';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { CopyOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import message from 'antd/lib/message';

const CopyButton = ({ id }) => {
    const intl = useIntl();
    return (
        <CopyToClipboard
            text={id}
            onCopy={(e, success) => {
                if (success) {
                    message.success(intl.formatMessage({ id: 'success.copy' }));
                } else {
                    message.warning(intl.formatMessage({ id: 'warning.copy' }));
                }
            }}
        >
            <Button icon={<CopyOutlined />} />
        </CopyToClipboard>
    );
};

CopyButton.propTypes = {
    id: PropTypes.string.isRequired,
};

export default CopyButton;
